import { useStoreApi } from "@xyflow/react";
import { useEffect } from "react";
import { scheduleChromeCollision } from "../../chromeCollision";

/**
 * Re-measures chrome collisions whenever nodes or the viewport change —
 * one throttled sweep, no React re-renders (see chromeCollision.ts).
 * Mount once inside <ReactFlow>.
 */
export function ChromeCollisionBridge() {
  const store = useStoreApi();
  useEffect(() => {
    scheduleChromeCollision();
    return store.subscribe((state, prev) => {
      if (state.nodes !== prev.nodes || state.transform !== prev.transform) {
        scheduleChromeCollision();
      }
    });
  }, [store]);
  return null;
}
